// NGRX
import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import { AuthActionTypes } from '../auth';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AppState {
  // that interface will be fill by all reducers (this is contained all reducers when add new reducer it will add here)
}
// define type of reducers ,,,acording the method forRoot on app.module the type it is ActionReducerMap and it is
// generic type(interface)
export const reducers: ActionReducerMap<AppState> = { router: routerReducer };

export const metaReducers: Array<MetaReducer<AppState>> = [clearState];

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  // tslint:disable-next-line:only-arrow-functions
  return function (state, action) {
    if (action.type === AuthActionTypes.Logout) {
      state = {};
    }
    return reducer(state, action);
  };
}
